import React from "react";
import PropTypes from "prop-types";

const SearchListItem = ({ link, backgroundImage, title, subtitle, children }) => (
  <li className="myad-search-list__item">
    <a href={link} target="_blank" rel="noreferrer">
      <figure>
        <img src={backgroundImage} alt={title} />
      </figure>
      <h3 className="myad-search-list__title">{title}</h3>
      <p className="myad-search-list__subtitle">{subtitle}</p>
    </a>
    {children}
  </li>
);

SearchListItem.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  backgroundImage: PropTypes.string.isRequired,
  children: PropTypes.node
};

SearchListItem.defaultProps = {
  children: null
};

export default SearchListItem;
